<p-dialog
	*ngIf="shareCheckView"
	[(visible)]="shareCheckView"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
	(onHide)="shareCheckView = false; shareCheckViewChange.emit(false)"
>
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'share-from-square']" class="me-4" size="2x"></fa-icon>
			<div class="display-8 ms-1 my-auto">Share your check</div>
		</div>
		<p-divider></p-divider>
	</ng-template>
	<div class="d-flex flex-column w-100" *ngIf="shareCheckUrl">
		<div class="mx-auto display-10">Share your experience with your friends and family.</div>
		<div class="mx-auto display-10">Scan the QR code below to share your check.</div>
		<div class="mx-auto" (click)="app.copyMessage(shareCheckUrl)">
			<qrcode [qrdata]="shareCheckUrl" width="256" errorCorrectionLevel="'M'"></qrcode>
		</div>
	</div>
</p-dialog>
